module.exports = __webpack_public_path__ + "media/images/gallery/figure_off-2435e3994d7e93c88e941006a4e50d6a.gif";